import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Spinner from "../components/Spinner";
import { FaRandom } from "react-icons/fa";

const CreateUser = () => {
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [celular, setCelular] = useState("");
  const [perfil, setPerfil] = useState("Atleta");
  const [loading, setLoading] = useState(false);

  // Atletas representados
  const [atletasList, setAtletasList] = useState([]);
  const [selectedRepresentados, setSelectedRepresentados] = useState([]);
  const [searchAtletaTerm, setSearchAtletaTerm] = useState("");

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const token = localStorage.getItem("token");

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    const fetchAtletas = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas`,
          config
        );
        const data = response.data?.data || [];
        setAtletasList(data);
      } catch (error) {
        console.error("Erro ao carregar atletas:", error);
      }
    };
    fetchAtletas();
  }, []);

  const handleToggleAtleta = (atleta) => {
    setSelectedRepresentados((prev) => {
      const exists = prev.some((a) => a._id === atleta._id);
      if (exists) {
        return prev.filter((a) => a._id !== atleta._id);
      } else {
        return [...prev, { _id: atleta._id, nome: atleta.nome }];
      }
    });
  };

  const handleSaveUser = async () => {
    if (!nome || !password || !perfil) {
      enqueueSnackbar("Preencha todos os campos obrigatórios", {
        variant: "warning",
      });
      return;
    }

    setLoading(true);

    try {
      const formData = {
        nome,
        email,
        password,
        celular,
        perfil,
        atletasRepresentados: selectedRepresentados.map((a) => a._id),
      };

      await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas/create`,
        formData,
        config //para token
      );

      enqueueSnackbar("Usuário cadastrado com sucesso", { variant: "success" });
      setNome("");
      setCelular("");
      setPassword("");
      setEmail("");
      setSelectedRepresentados([]);
      setSearchAtletaTerm("");
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(
        "Erro ao salvar usuário: " +
          (error.response?.data?.message || error.message),
        { variant: "error" }
      );
    } finally {
      setLoading(false);
    }
  };

  const [generatingCode, setGeneratingCode] = useState(false);

  const handleGerarCodigoAleatorio = async () => {
    setGeneratingCode(true);
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/atletas/gerar-codigo`,
        config
      );
      if (response.data?.code) {
        setPassword(response.data.code);
        enqueueSnackbar(`Código único gerado: ${response.data.code}`, {
          variant: "success",
        });
      }
    } catch (error) {
      console.error("Erro ao gerar código:", error);
      enqueueSnackbar("Erro ao gerar código aleatório", { variant: "error" });
    } finally {
      setGeneratingCode(false);
    }
  };

  const handleCelularChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, ""); // Remove caracteres não numéricos
    setCelular(numericValue);
    // Se o usuário ainda não gerou ou não digitou senha customizada, pode sugerir pelo celular
    if (!password || password.length <= 5) {
      setPassword(nome.slice(0, 1).toUpperCase() + numericValue.slice(-4));
    }
  };

  const filteredAtletas = atletasList.filter((a) =>
    a.nome?.toLowerCase().includes(searchAtletaTerm.toLowerCase())
  );

  return (
    <div className="p-6 bg-base-100 flex justify-center items-center mt-16">
      {loading && <Spinner />}
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-100">
        <h1 className="text-3xl font-semibold my-4">Cadastrar usuário</h1>
        <div className="my-4">
          <label htmlFor="nome" className="block text-md mb-2">
            Nome*
          </label>
          <input
            id="nome"
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
            required
          />

          <label htmlFor="celular" className="block text-md mb-2 mt-4">
            Celular
          </label>
          <input
            id="celular"
            type="text"
            value={celular}
            onChange={handleCelularChange}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />

          <div className="flex justify-between items-center mb-2 mt-4">
            <label htmlFor="password" className="block text-md font-medium">
              Código de Acesso / Senha*
            </label>
            <button
              type="button"
              onClick={handleGerarCodigoAleatorio}
              disabled={generatingCode}
              className="btn btn-xs btn-outline btn-secondary gap-1"
              title="Gerar código aleatório alfanumérico único"
            >
              {generatingCode ? (
                <span className="loading loading-spinner loading-xs"></span>
              ) : (
                <FaRandom />
              )}
              <span>Gerar aleatório</span>
            </button>
          </div>
          <input
            id="password"
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value.toUpperCase())}
            placeholder="Ex: K9B7X2"
            className="border border-base-300 px-4 py-2 w-full rounded-md font-mono font-bold"
            required
          />
          <span className="text-xs text-base-content/60 mt-1 block">
            Código alfanumérico único para o atleta acessar a loja ou link direto.
          </span>

          <label htmlFor="perfil" className="block text-lg mb-2 mt-4">
            Perfil*
          </label>
          <select
            id="perfil"
            defaultValue="Atleta"
            onChange={(e) => setPerfil(e.target.value)}
            className="w-full border border-base-300 px-4 py-2 rounded-md"
            required
          >
            <option value="" disabled>
              Selecione o perfil
            </option>
            <option value="Atleta">Atleta</option>
            <option value="Assessoria">Assessoria</option>
          </select>

          {/* Seleção de atletas que este usuário representa */}
          <div className="mt-4 border border-base-300 rounded-md p-3 bg-base-200/40">
            <label className="block text-md font-medium mb-1">
              Atletas representados <span className="text-xs font-normal opacity-70">(opcional)</span>
            </label>
            <p className="text-xs text-info font-medium mb-1">
              ✓ Por padrão, cada atleta sempre vê todas as fotos marcadas para ela.
            </p>
            <p className="text-xs opacity-75 mb-2">
              Use este campo caso este usuário também represente outros atletas (ex: assessorias ou pais), podendo ver e comprar fotos deles também.
            </p>

            {selectedRepresentados.length > 0 && (
              <div className="flex flex-wrap gap-1.5 mb-2">
                {selectedRepresentados.map((a) => (
                  <span
                    key={a._id}
                    className="badge badge-primary gap-1 py-3 px-2 text-xs"
                  >
                    {a.nome}
                    <button
                      type="button"
                      onClick={() => handleToggleAtleta(a)}
                      className="hover:text-red-300 ml-1 font-bold"
                      title="Remover"
                    >
                      ✕
                    </button>
                  </span>
                ))}
              </div>
            )}

            <input
              type="text"
              placeholder="Buscar atleta para adicionar..."
              value={searchAtletaTerm}
              onChange={(e) => setSearchAtletaTerm(e.target.value)}
              className="border border-base-300 px-3 py-1.5 w-full rounded-md text-sm mb-2 bg-base-100"
            />

            <div className="max-h-40 overflow-y-auto border border-base-300 rounded-md p-2 bg-base-100 divide-y divide-base-200">
              {filteredAtletas.length > 0 ? (
                filteredAtletas.map((atleta) => {
                  const isChecked = selectedRepresentados.some(
                    (a) => a._id === atleta._id
                  );
                  return (
                    <label
                      key={atleta._id}
                      className="flex items-center gap-2 py-1.5 px-1 hover:bg-base-200 rounded cursor-pointer text-sm"
                    >
                      <input
                        type="checkbox"
                        className="checkbox checkbox-sm checkbox-primary"
                        checked={isChecked}
                        onChange={() => handleToggleAtleta(atleta)}
                      />
                      <span className="font-medium">{atleta.nome}</span>
                      {atleta.perfil && (
                        <span className="text-[11px] opacity-60 ml-auto">
                          {atleta.perfil}
                        </span>
                      )}
                    </label>
                  );
                })
              ) : (
                <div className="text-xs text-center py-2 opacity-60">
                  Nenhum atleta encontrado
                </div>
              )}
            </div>
          </div>

          <label htmlFor="email" className="block text-md  mb-2 mt-4">
            E-mail
          </label>

          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-base-300 px-4 py-2 w-full rounded-md"
          />
          <button
            onClick={handleSaveUser}
            className="w-full bg-green-500
                              hover:bg-green-800 text-white py-2 px-4 rounded-md mt-4"
          >
            Salvar
          </button>
          <Link to="/admin/atletas" className="btn mt-5">
            Voltar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CreateUser;
